export default __webpack_public_path__ + "static/media/lucene.net.28cfbf22.svg";